export const specilistsData = [
  {
    name: 'Dra. Aline Erthal',
    specialty: 'Dermatologia',
    registry: 'CRM SP 199764',
    rqe: 'RQE 98608',
    profilePath: '/author/dra-aline-erthal',
    background: ['Graduada pela Faculdade de Medicina da USP.'],
    publicationLink: 'https://saude.abril.com.br/coluna/com-a-palavra/identificar-o-tipo-de-calvicie-e-essencial/',
    imgSrc: '/landings/dermatology/aline.webp',
    linkText: 'Publicações na mídia'
  },
  {
    name: 'Dr. João Brunhara',
    specialty: 'Saúde Sexual',
    registry: 'CRM SP 161642',
    rqe: 'RQE 118506',
    profilePath: '/author/dr-joao-brunhara',
    background: [
      'Graduado pela Faculdade de Medicina da USP.',
      'Médico preceptor da divisão Urologia do Hospital das Clínicas.',
      'Corpo clínico Hospital Israelita Albert Einstein.',
      'Corpo clínico Hospital Sírio Libanês',
      'Consultor científico da American Urological Association'
    ],
    publicationLink: 'https://saude.abril.com.br/coluna/coisas-de-homens',
    imgSrc: '/landings/dr-joao.webp',
    linkText: 'Colunista na revista Veja'
  }
]
